export default __webpack_public_path__ + "static/media/office365-negative.9b731226.svg";